import { handleActions } from "redux-actions";

import sort from "utils/incentives/sort";
import removeById from "utils/removeById";
import updateById from "utils/updateById";

const incentiveReducer = handleActions(
  {
    INCENTIVE_GET_PENDING: () => ({
      incentive: null,
    }),

    INCENTIVE_GET_FULFILLED: (_, { payload: { incentive } }) => ({
      incentive,
    }),

    INCENTIVES_GET_FULFILLED: (_, { payload: { incentives } }) => ({
      incentives: sort(incentives),
    }),

    INCENTIVE_CREATE_FULFILLED: ({ incentives }, { payload: { incentive } }) => ({
      incentives: sort([incentive, ...incentives]),
    }),

    INCENTIVE_DELETE_FULFILLED: ({ incentives }, { meta: { id } }) => ({
      incentives: removeById(incentives, id),
      incentive: null,
    }),

    INCENTIVE_SAVE_FULFILLED: ({ incentives }, { payload: { incentive } }) => ({
      incentives: sort(updateById(incentives, incentive)),
    }),
  },
  {},
  { namespace: "_" }
);

export default incentiveReducer;
